<template>
  <div>
    <div>
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="板块:">
            <el-select v-model="obj.block" @change="handleSelectChange" style="width:120px" disabled="true">
              <el-option v-for="item in obj.blockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="期间:">
            <el-select v-model="obj.day" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.dayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信号多空:">
            <el-select v-model="obj.trend" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.trendList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信号强度:">
            <el-select v-model="obj.level" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.level_List" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开平仓条件:">
            <el-select v-model="obj.operationLevel" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.operationLevel_list" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <cpu />
              </el-icon>筛选
            </el-button>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" @click="handleRefresh">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
    </div>
    <div>
      <el-tag type="warning" size="small" v-if="obj.date !== ''">更新日： {{ obj.date }}</el-tag>
    </div>
    <div>
      <!-- <el-tag type="warning" size="small">最新信号</el-tag> -->
    </div>
    <div>
      <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) * 3 / 5 + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick2" highlight-current-row ref="singleTableRef">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="140px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chgPct" width="100px" align="right" :sort-method="customPctSort" sortable />
        <el-table-column label="板块" prop="industry" width="100px" align="right" sortable />
        <el-table-column label="15分钟线" prop="trend_min_15" width="240px" align="left" sortable />
        <el-table-column label="1小时线" prop="trend_hour_1" width="240px" align="left" sortable />
        <el-table-column label="日线" prop="trend_day_1" width="240px" align="left" sortable />
        <el-table-column label="周线" prop="trend_week_1" width="240px" align="left" sortable />
        <el-table-column label="趋势得分" prop="trend_point" width="120px" align="right" sortable />
      </el-table>
    </div>
    <div>
      <el-tag type="warning" size="small">板块指数</el-tag>
    </div>
    <div>
      <el-table :data="obj.dataList2" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 0) * 2 / 5 + 'px'" :cell-style="cellStyle2"
        @row-click="handleRowClick2" highlight-current-row ref="singleTableRef">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="140px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chg2Pct" width="100px" align="right" :sort-method="customPct2Sort" sortable />
        <el-table-column label="板块" prop="industry" width="100px" align="right" sortable />
        <el-table-column label="15分钟线" prop="trend_min_15" width="240px" align="left" sortable />
        <el-table-column label="1小时线" prop="trend_hour_1" width="240px" align="left" sortable />
        <el-table-column label="日线" prop="trend_day_1" width="240px" align="left" sortable />
        <el-table-column label="周线" prop="trend_week_1" width="240px" align="left" sortable />
        <el-table-column label="趋势得分" prop="trend_point" width="120px" align="right" sortable />
      </el-table>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const singleTableRef = ref()
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      blockList: [
        {
          value: '',
          label: '全部'
        }
      ],
      block: '',
      dayList: [
        {
          value: '1',
          label: '最近1日'
        },
        {
          value: '2',
          label: '最近2日'
        },
        {
          value: '3',
          label: '最近3日'
        },
        {
          value: '4',
          label: '最近4日'
        },
        {
          value: '5',
          label: '最近5日'
        },
      ],
      day: '1',
      trendList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'Long',
          label: '多头'
        },
        {
          value: 'Short',
          label: '空头'
        },
      ],
      trend: '',
      level_List: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '1级'
        },
        {
          value: '2',
          label: '2级'
        },
        {
          value: '3',
          label: '3级'
        },
        {
          value: '4',
          label: '4级'
        },
        {
          value: '5',
          label: '5级'
        },
      ],
      level: '',
      operationLevel_list: [
        {
          value: '3',
          label: '3级以上'
        },
        {
          value: '4',
          label: '4级以上'
        },
        {
          value: '5',
          label: '5级'
        },
      ],
      operationLevel: '5',
      dataList: [],
      dataList2: [],
      date: '',
      selectedBlock: '',
      selectedBlockValue: '',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.trendData === '') {
        // 无缓存，从后台请求数据
        requestData()
        requestData2()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      formData.append("block", obj.block)
      http({
        url: `/trend`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        obj.dataList = processData(res.data.data)
        setStore()
      })
    }

    // 后台获取数据2
    const requestData2 = () => {
      let formData = new FormData()
      formData.append("block", "block")
      http({
        url: `/trend`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        obj.dataList2 = processData2(res.data.data)
        setStore()
      })
    }

    // const setCurrent = (row) => {
    //   singleTableRef.value.setCurrentRow(row)
    // }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.forEach((item) => {
        obj.date = item.date
        if (item.chgPct !== "-") {
          item.chgPct = parseFloat(item.chgPct * 100).toFixed(2) + '%'
        }
        item.no = no
        no++
      })
      return data
    }

    // 处理数据
    const processData2 = (data) => {
      let no = 1
      data.forEach((item) => {
        if (item.chg2Pct !== "-") {
          item.chg2Pct = parseFloat(item.chg2Pct * 100).toFixed(2) + '%'
        }
        if (item.profit != "-") {
          item.profit = parseFloat(item.profit * 100).toFixed(2) + '%'
        }
        item.no = no
        no++
      })
      return data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'block': obj.block,
        'day': obj.day,
        'trend': obj.trend,
        'level': obj.level,
        'operationLevel': obj.operationLevel,
        'dataList': obj.dataList,
        'dataList2': obj.dataList2,
        'date': obj.date,
        'selectedBlock': obj.selectedBlock,
        'selectedBlockValue': obj.selectedBlockValue
      }
      store.commit('setTrendData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.block = store.state.trendData.block
      obj.day = store.state.trendData.day
      obj.trend = store.state.trendData.trend
      obj.level = store.state.trendData.level
      obj.operationLevel = store.state.trendData.operationLevel
      obj.date = store.state.trendData.date
      obj.dataList = store.state.trendData.dataList
      obj.dataList2 = store.state.trendData.dataList2
      obj.selectedBlock = store.state.trendData.selectedBlock
      obj.selectedBlockValue = store.state.trendData.selectedBlockValue
    }

    // 重置画面
    const resetView = () => {
      obj.block = ''
      obj.day = 3
      obj.trend = ''
      obj.level = ''
      obj.operationLevel = ''
      obj.date = ''
      obj.dataList = []
      obj.dataList = ''
      obj.dataList2 = []
      obj.dataList2 = ''
      obj.selectedBlock = ''
      obj.selectedBlockValue = ''
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      requestData()
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      obj.selectedBlock = row.name
      obj.selectedBlockValue = row.symbol
      requestData2(obj.selectedBlock)
    }

    // 表格行点击事件2
    const handleRowClick2 = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 按钮提交事件
    const handleSubmit = () => {
      // if (!formCheck()) {
      //   return
      // }
      obj.selectedBlock = ""
      obj.selectedBlockValue = ""
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.indicators.trim() === '' && obj.patterns.trim() === '' &&
        (obj.customize.trim() === '' || obj.symbols.trim() === '')) {
        ElMessage.error('请选择或输入条件')
        return false
      }
      return true
    }

    // 开平仓
    const handleOperation = (index, row) => {
      // console.log(index, row)
      let formData = new FormData()
      formData.append("name", row.name)
      formData.append("open_close", row.open_close)
      formData.append("direction", row.direction)
      formData.append("quantity", row.quantity)
      formData.append("price", row.close)
      http({
        url: `/trade`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success('操作成功')
        row.open_close = -1
        row.direction = -1
        row.quantity = -1
        // vueEvent.emit('updateBalanceEvent')
      })
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.trend_min_15.toString().includes("多头") && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.trend_min_15.toString().includes("空头") && row.columnIndex === 6) {
        return { color: 'green' }
      } else if (row.row.trend_min_15.toString().includes("大阳") && row.columnIndex === 6) {
        return { color: 'orange' }
      } else if (row.row.trend_min_15.toString().includes("大阴") && row.columnIndex === 6) {
        return { color: 'orange' }
      }
      if (row.row.trend_hour_1.toString().includes("多头") && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.trend_hour_1.toString().includes("空头") && row.columnIndex === 7) {
        return { color: 'green' }
      } else if (row.row.trend_hour_1.toString().includes("大阳") && row.columnIndex === 7) {
        return { color: 'orange' }
      } else if (row.row.trend_hour_1.toString().includes("大阴") && row.columnIndex === 7) {
        return { color: 'orange' }
      }
      if (row.row.trend_day_1.toString().includes("多头") && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.trend_day_1.toString().includes("空头") && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.trend_week_1.toString().includes("多头") && row.columnIndex === 9) {
        return { color: 'red' }
      } else if (row.row.trend_week_1.toString().includes("空头") && row.columnIndex === 9) {
        return { color: 'green' }
      }
      if (row.row.trend_point > 0 && row.columnIndex === 10) {
        return { color: 'red' }
      } else if (row.row.trend_point < 0 && row.columnIndex === 10) {
        return { color: 'green' }
      }
    }

    // 表格单元格样式2
    const cellStyle2 = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg2Pct.toString().replace('%', '') > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg2Pct.toString().replace('%', '') < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.trend_min_15.toString().includes("多头") && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.trend_min_15.toString().includes("空头") && row.columnIndex === 6) {
        return { color: 'green' }
      } else if (row.row.trend_min_15.toString().includes("大阳") && row.columnIndex === 6) {
        return { color: 'orange' }
      } else if (row.row.trend_min_15.toString().includes("大阴") && row.columnIndex === 6) {
        return { color: 'orange' }
      }
      if (row.row.trend_hour_1.toString().includes("多头") && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.trend_hour_1.toString().includes("空头") && row.columnIndex === 7) {
        return { color: 'green' }
      } else if (row.row.trend_hour_1.toString().includes("大阳") && row.columnIndex === 7) {
        return { color: 'orange' }
      } else if (row.row.trend_hour_1.toString().includes("大阴") && row.columnIndex === 7) {
        return { color: 'orange' }
      }
      if (row.row.trend_day_1.toString().includes("多头") && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.trend_day_1.toString().includes("空头") && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.trend_week_1.toString().includes("多头") && row.columnIndex === 9) {
        return { color: 'red' }
      } else if (row.row.trend_week_1.toString().includes("空头") && row.columnIndex === 9) {
        return { color: 'green' }
      }
      if (row.row.trend_point > 0 && row.columnIndex === 10) {
        return { color: 'red' }
      } else if (row.row.trend_point < 0 && row.columnIndex === 10) {
        return { color: 'green' }
      }
    }


    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    // 表格排序(带百分号的数字列)
    const customPct2Sort = (a, b) => {
      return parseFloat(a.chg2Pct.replace('%', '')) - parseFloat(b.chg2Pct.replace('%', ''))
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleRefresh,
      handleRowClick,
      handleRowClick2,
      handleSubmit,
      handleOperation,
      cellStyle,
      cellStyle2,
      customPctSort,
      customPct2Sort
    }
  }
}
</script>
<style lang="scss" scoped></style>
